import { useNavigate } from 'react-router-dom'

export function DashboardESign() {
  const navigate = useNavigate()

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-[#bceda6] font-robo'>
      <div className='w-full max-sm:scale-90 flex flex-col items-center'>
        <p className='font-bold text-3xl text-center mt-4'>E-Signature!</p>
        <div className='flex flex-col items-center gap-4 mt-10'>
          <p>We have approved your SETC Packet, and are now ready for your E-Signature.</p>
          <button onClick={() => navigate('/esign')} className={`flex flex-col items-center gap-4 px-4 py-4 rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition duration-200`}>
            <p>Get Started</p>
          </button>
        </div>
      </div>
    </div>
  )
}